"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ProductUpdateTopicView = _interopRequireDefault(require("../product-updates-destination/ProductUpdateTopicView"));

var _TopicFeaturedImage = _interopRequireDefault(require("../topic-list-view/TopicFeaturedImage"));

var _TopicHeader = _interopRequireDefault(require("../topic-list-view/TopicHeader"));

var _classnames = _interopRequireDefault(require("classnames"));

var ProductUpdatePreview = function ProductUpdatePreview(_ref) {
  var topic = _ref.topic,
      attachmentCdn = _ref.attachmentCdn,
      authorData = _ref.authorData;
  return (0, _preact.h)("div", {
    className: "box qa-topic-first-post",
    "data-helper": "class-toggle"
  }, (0, _preact.h)(_TopicHeader.default, {
    title: topic.title,
    contentType: topic.contentType,
    publicLabel: topic.publicLabel,
    productAreas: topic.productAreas,
    replies: 0,
    views: 0
  }), topic.featuredImage ? (0, _preact.h)(_TopicFeaturedImage.default, {
    src: (0, _absoluteUrlRuntime.resolveUrl)(topic.featuredImage),
    alt: topic.featuredImageAltText || topic.title
  }) : (0, _preact.h)("hr", {
    className: (0, _classnames.default)('seperator', 'm-h', 'm-b-0')
  }), (0, _preact.h)(_ProductUpdateTopicView.default, {
    topic: topic,
    attachmentCdn: attachmentCdn,
    disableFileAttachments: false,
    authorData: authorData
  }));
};

var _default = ProductUpdatePreview;
exports.default = _default;